const ensureBrowser = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    throw new Error("PDF actions require a browser environment.");
  }
};

const fetchPdfBlob = async (fileUrl) => {
  const response = await fetch(fileUrl, { credentials: "omit" });
  if (!response.ok) {
    throw new Error("Unable to fetch the invoice PDF.");
  }
  return response.blob();
};

export const downloadPdfUrl = async (fileUrl, filename = "invoice.pdf") => {
  ensureBrowser();
  const blob = await fetchPdfBlob(fileUrl);
  const blobUrl = window.URL.createObjectURL(blob);
  const downloadLink = document.createElement("a");
  downloadLink.href = blobUrl;
  downloadLink.download = filename;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.remove();
  window.URL.revokeObjectURL(blobUrl);
};

export const printPdfUrl = async (fileUrl) => {
  ensureBrowser();
  const blob = await fetchPdfBlob(fileUrl);
  const blobUrl = window.URL.createObjectURL(blob);
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.opacity = "0";
  iframe.style.pointerEvents = "none";
  iframe.src = blobUrl;
  document.body.appendChild(iframe);

  await new Promise((resolve, reject) => {
    iframe.onload = () => {
      try {
        window.setTimeout(() => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
          resolve();
        }, 700);
      } catch (error) {
        reject(error);
      }
    };
    iframe.onerror = () => reject(new Error("Unable to load the generated PDF for printing."));
  });

  window.setTimeout(() => {
    iframe.remove();
    window.URL.revokeObjectURL(blobUrl);
  }, 2000);
};